import { render, staticRenderFns } from "./bookBoxTab.vue?vue&type=template&id=bfdcd05c&"
import script from "./bookBoxTab.vue?vue&type=script&lang=js&"
export * from "./bookBoxTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports